import containerFuild from '../html-snippets/container-fuild.js';
import buttonPrimary from '../../../views/website/products/components/description/ui-modules/button-primary/raw-html.js';
import css from '../css-snippets/section-orthopedic-card-review.js';

const SIDE_IMAGE = 'https://cdn.skyfastimg.com/images/2026/06/23/image-6a3a2e5cc67a0ede193136ea.png?w=1000&h=50&q=80';

const STAR_SVG = `
<svg width="30" height="29" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.7415 0L18.2214 10.7102H29.4828L20.3722 17.3295L23.8521 28.0398L14.7415 21.4205L5.63078 28.0398L9.11075 17.3295L7.9155e-05 10.7102H11.2615L14.7415 0Z" fill="#FFCC00"/>
</svg>
`;

const LOCK_SVG = `<svg
  width="18"
  height="20"
  viewBox="0 0 18 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M9 13V15M3 19H15C16.1046 19 17 18.1046 17 17V11C17 9.89543 16.1046 9 15 9H3C1.89543 9 1 9.89543 1 11V17C1 18.1046 1.89543 19 3 19ZM13 9V5C13 2.79086 11.2091 1 9 1C6.79086 1 5 2.79086 5 5V9H13Z"
    stroke="#006196"
    stroke-width="2"
    stroke-linecap="round"
  />
</svg>
`;

const buttonHtml = buttonPrimary({
  text: 'Shop Now With Our Guarantee!',
  backgroundColor: '#006196',
  radius: 12,
  iconPrefix: { show: false, src: '' },
  iconSuffix: { show: false, src: '' },
  subBtn: { show: false, text: '' },
});

const contentHtml = `
  <div
    class="orthopedic-card-review container"
    data-attribute="orthopedic-card-review-content"
    data-image-position="right"
    data-gap="60"
    style="--section-gap: 60px;"
  >
    <div class="orthopedic-card-review__image" data-attribute="orthopedic-card-review__image">
      <img
        data-attribute="orthopedic-card-review__image-img"
        src="${SIDE_IMAGE}"
        alt=""
      />
    </div>
    <div class="orthopedic-card-review__content" data-attribute="orthopedic-card-review__content">
      <div
        class="orthopedic-card-review__rating"
        data-attribute="orthopedic-card-review__rating"
        data-show="true"
      >
        <div class="orthopedic-card-review__rating-stars" data-attribute="orthopedic-card-review__rating-stars">
          ${STAR_SVG}${STAR_SVG}${STAR_SVG}${STAR_SVG}${STAR_SVG}
        </div>
        <div class="orthopedic-card-review__rating-text" data-attribute="orthopedic-card-review__rating-text">
          14,000+ Happy Customers
        </div>
      </div>
      <div class="orthopedic-card-review__title" data-attribute="orthopedic-card-review__title">
        <h2><span style="color:hsl( 201, 100%, 29% );font-size:42px;"><strong>YOU'LL FEEL THE DIFFERENCE INSTANTLY!</strong></span></h2>
      </div>
      <div
        class="orthopedic-card-review__guarantee"
        data-attribute="orthopedic-card-review__guarantee"
        data-show="true"
        data-background="#F2F7F9"
        data-text-color="#006196"
        style="--guarantee-bg: #F2F7F9; --guarantee-text: #006196;"
      >
        <div class="orthopedic-card-review__guarantee-icon" data-attribute="orthopedic-card-review__guarantee-icon">
          ${LOCK_SVG}
        </div>
        <div class="orthopedic-card-review__guarantee-text" data-attribute="orthopedic-card-review__guarantee-text">
          Try Risk Free | 30-Day Wear Test Guarantee
        </div>
      </div>
      <div class="orthopedic-card-review__body" data-attribute="orthopedic-card-review__body">
        <p><span style="font-size:24px;color:hsl( 0, 0%, 15% )">Our orthopedic shoes are lightweight, comfy, and built for all-day support. With great cushioning and slip-resistant soles, they're perfect for long shifts on any surface.</span></p>
        <p><span style="font-size:24px;color:hsl( 0, 0%, 15% )">Whether you're in healthcare, retail, or hospitality, they'll keep your feet, legs, and back feeling good all day.</span></p>
      </div>
      ${buttonHtml}
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  topPadding: true,
  bottomPadding: true,
  textColor: '#545559',
});
